import { Component, OnInit, inject } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ECLConfigService } from '@lmc-app/core/services/ecl-config.service';
import { SnackbarConstants } from '@lmc-app/shared/constants/snackbar.constant';
import { Loading } from '../../applications/loading';

@Component({
	selector: 'app-ecl-config',
	templateUrl: './ecl-config.component.html',
	styleUrls: ['./ecl-config.component.scss'],
})
export class ECLConfigComponent implements OnInit {
	protected columns = [
		{
			headerName: 'Stage',
			field: 'stage',
			editable: true,
			width: 40,
		},
		{
			headerName: 'Risk',
			field: 'risk',
			editable: true,
			width: 40,
		},
		{
			headerName: 'Base PD',
			field: 'base_pd',
			editable: true,
			width: 40,
			valueFormatter: (params: { value: number }) => {
				if (params.value == null) return '';
				return `${params.value.toFixed(2)}%`;
			},
		},
		{
			headerName: 'PD Macro Overlay',
			field: 'pd_macro_overlay',
			editable: true,
			width: 40,
		},
		{
			headerName: 'Adjusted PD',
			field: 'adjusted_pd',
			editable: true,
			width: 40,
		},
		{
			headerName: 'LGD',
			field: 'lgd',
			editable: true,
			width: 40,
			valueFormatter: (params: { value: number }) => {
				if (params.value == null) return '';
				return `${params.value.toFixed(2)}%`;
			},
		},
		{
			headerName: 'Weighted LGD',
			field: 'weighted_lgd',
			editable: true,
			width: 40,
		},
	];
	protected eclConfig: ECLConfig[] = [];
	protected filteredECLConfig: ECLConfig[] = [];
	// Loading states
	protected isLoading: boolean = false;
	private readonly _bottomSheet = inject(MatBottomSheet);
	private readonly _snackBar = inject(MatSnackBar);

	constructor(
		private eclConfigService: ECLConfigService,
	) { }

	ngOnInit(): void {
		this.isLoading = true;
		this.getECLConfig();
	}

	getECLConfig() {
		this.eclConfigService.getECLConfig().subscribe({
			next: (res) => {
				this.eclConfig = res;
				this.filteredECLConfig = this.eclConfig;
				this.isLoading = false;
			},
			error: (err) => {
				console.error(err);
				this.isLoading = false;
			},
		});
	}

	protected onCellValueChanged(e: { data: { id: number } }) {
		this._bottomSheet.open(Loading, {
			disableClose: true,
			data: { message: 'Saving' },
		});
		this.eclConfigService.updateECLConfig(e.data).subscribe({
			next: () => {
				this.getECLConfig();
				this._snackBar.open(
					`ECL Config ${e.data.id} is updated.`,
					SnackbarConstants.ACTION_DISMISS,
					SnackbarConstants.DURATION_DISMISS_SHORT
				);
				this._bottomSheet.dismiss();
			},
			error: (error) => {
				this.getECLConfig();
				this._bottomSheet.dismiss();
				console.error(error);
				this._snackBar.open(
					(error.error && (error.error.message && (error.error.message.name || error.error.message))) || 'Error updating ECL Config.',
					SnackbarConstants.ACTION_DISMISS,
					SnackbarConstants.DURATION_DISMISS_SHORT
				);
			},
		});
	}
}
